import { Spinner } from "@components/ui-kit";
import { NotFoundProforma } from "@components/widgets/ErrorPage";
import { useProformaInvoiceQuery } from "@src/__generated__/graphql";
import { useStore } from "@src/utils/hooks";
import { FormMode } from "@src/utils/types";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { Container } from "../components";
import { InvoiceStore, InvoiceStoreContext, InvoiceTypeEnum } from "../store";

interface EditProformaProps {
  id: string;
}

export const EditProforma = observer(function EditProforma({
  id,
}: EditProformaProps) {
  const appStore = useStore();
  const [store] = useState(
    () =>
      new InvoiceStore(
        appStore,
        false,
        InvoiceTypeEnum.Proforma,
        FormMode.EDIT,
      ),
  );

  const { data, loading } = useProformaInvoiceQuery({
    variables: { id },
    skip: !id,
    onCompleted(data) {
      if (data.outgoingProformaInvoice) {
        store.setDataFromProforma(data.outgoingProformaInvoice);
      }
    },
  });

  if (loading) {
    return <Spinner absolute />;
  }

  if (!data?.outgoingProformaInvoice) {
    return <NotFoundProforma />;
  }

  if (!store.invoice_id) {
    return null;
  }

  return (
    <InvoiceStoreContext.Provider value={store}>
      <Container />
    </InvoiceStoreContext.Provider>
  );
});
